export const GET_SHIPPING_CATEGORY_REQUESTED    = 'GET_SHIPPING_CATEGORY_REQUESTED';
export const GET_SHIPPING_CATEGORY_SUCCESS      = 'GET_SHIPPING_CATEGORY_SUCCESS';
export const GET_SHIPPING_CATEGORY_FAILED       = 'GET_SHIPPING_CATEGORY_FAILED';
